import { get_state, State } from "../../redux/State";
import { Drawing } from "../../drawings/Drawing";
import { DrawingsCollection } from "../../drawings/DrawingsCollection";
import { Id_drawing, Id_floor } from "../../api/Identifiers";

// this is called from JS Land. it will eventually go away
export function update_drawings_buttons_temp(): void {
    let state: State = get_state();
    let id_floor: Id_floor = state.id_floor;
    let drawings: DrawingsCollection = state.selected_building_drawings.get_all_in_floor(id_floor);

    // drawings.get_all_in_building(id_floor).drawings.forEach(drawing =>{
    //     if (drawing.id_floor.value===id_floor.value){
    //         drawings.push(drawing)
    //     }
    // })

    update_drawings_buttons(drawings.drawings, state.id_drawing);
}


// Draw map buttons for the drawings listed. highlight the button for the current drawing.
// this function directly manipulates the UI
export function update_drawings_buttons(drawings: Drawing[], current_id_drawing: Id_drawing): void {
    // hide all buttons
    for (let i: number = 0; i < 10; i++) {
        $("#map_" + i + "_button").hide();
    }

    let first_drawing_is_selected: boolean = false;
    let found_selected_drawing: boolean = false;

    let displayable_drawings:Drawing[] = drawings.filter((drawing:Drawing) => {
        return drawing.is_dispalyable;
    });


    for (let i: number = 0; i < displayable_drawings.length; i++) {

        let drawing:Drawing = displayable_drawings[i];
        let id_drawing: Id_drawing = drawing.id;
        let label: string = drawing.drawing_description;
        let index: number = i;

        // want i=0 to be reserved for the button that is selected... 
        if (id_drawing.value === current_id_drawing.value) {
            index = 0;
            found_selected_drawing = true;
            if (i === 0) {
                first_drawing_is_selected = true;
            }
        }
        else if (!first_drawing_is_selected) { // first drawing is not the selected drawing
            if (!found_selected_drawing) { // selected drawing has not been found so everything needs to move down by 1
                index = index + 1;
            }

        }

        let btn: any = ($("#map_" + index + "_button") as any);
        let name: string = "map_" + index + "_button_span";
        let span2: HTMLSpanElement = <HTMLSpanElement>document.getElementById(name);
        btn.show();
        span2.style.visibility = "visible";
        span2.textContent = label;
        btn.data("id_drawing", id_drawing.value);
        if (id_drawing.value === current_id_drawing.value) {
            btn.css("background-color", "#009688");
        }
        else {
            btn.css("background-color", "");
        }
    }
}